import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_proto_nursery_decor: FaireCategoryEntity = {
  token: "cat_proto_nursery-decor",
  type: "category",
  name: "Nursery & decor",
  level: 1,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
